import React, { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import type { TenantThemeConfig } from '../types/theme'
import { useAuth } from '../contexts/AuthContext'
import { resolveReferralToken } from '../services/affiliateService'
import { LotteryResultSections } from './lottery-result'
import type { LotteryRound } from '../services/lotteryService'

const AFFILIATE_REFERRAL_KEY = 'affiliate_referral_code'

interface AssetConfig {
  CDN_BASE_URL: string
  CSS_PATH: string
  IMG_PATH: string
  FONTS_PATH: string
}

interface ClassicHomePageProps {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

/** รอบปิดรับและประกาศผลแล้วเท่านั้นถึงจะให้กดไปหน้าผล (เฉพาะเมื่อ login) */
function canNavigateToYeekeeResult(round: LotteryRound): boolean {
  return round?.status === 'closed' || round?.status === 'announced'
}

const ClassicHomePage: React.FC<ClassicHomePageProps> = (_props) => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const selectedDate = useMemo(() => {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Bangkok',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    return formatter.format(new Date())
  }, [])

  // Capture ?ref= (encrypted) or ?aff= (legacy) from URL for registration flow
  useEffect(() => {
    if (isAuthenticated) return
    const params = new URLSearchParams(window.location.search)
    const ref = params.get('ref')
    const aff = params.get('aff')
    if (ref && ref.trim()) {
      resolveReferralToken(ref.trim())
        .then(({ referralCode }) => {
          sessionStorage.setItem(AFFILIATE_REFERRAL_KEY, referralCode)
          navigate(`/register${window.location.search}`, { replace: true })
        })
        .catch(() => { /* invalid/expired ref — ไม่บันทึก */ })
    } else if (aff && aff.trim()) {
      sessionStorage.setItem(AFFILIATE_REFERRAL_KEY, aff.trim())
      navigate(`/register${window.location.search}`, { replace: true })
    }
  }, [isAuthenticated, navigate])

  return (
    <section className="content py-4">
      <div className="container">
        <LotteryResultSections
          selectedDate={selectedDate}
          onYeekeeRoundClick={
            isAuthenticated
              ? (r) => {
                  if (canNavigateToYeekeeResult(r)) {
                    navigate('/yeekee-result', { state: { round: r } })
                  }
                }
              : undefined
          }
          onYeekeeVipRoundClick={
            isAuthenticated
              ? (r) => {
                  if (canNavigateToYeekeeResult(r)) {
                    navigate('/yeekee-result', { state: { round: r } })
                  }
                }
              : undefined
          }
          showPoolError
          className="row mx--1"
        />
      </div>
    </section>
  )
}

export default ClassicHomePage
